import PortalVue from 'portal-vue';
// import { Plugin } from 'vue';
import directives from '@/setup/directives.js';
import i18n from '@/setup/i18n.js';
import components from '@/setup/ssr-components.js';
import api from '@/plugins/api.js';
import VueAxios from '@/plugins/axios.js';
import bodyScroll from '@/plugins/body-scroll/index.js';
import cdcPlugin from '@/plugins/cdc/index.js';
import confirmationModal from '@/plugins/confirmation-modal/confirmation.js';
import dayjs from '@/plugins/dayjs.js';
import googleTagManager from '@/plugins/google-tag-manager.js';
import Mitt from '@/plugins/mitt.js';
import resizeEnd from '@/plugins/resize-end.js';
import tooltip from '@/plugins/tooltip/plugin.js';
import vFocus from '@/plugins/v-focus/index.js';
import viewport from '@/plugins/viewport.js';
import VueBemCn from '@/plugins/vue-bem-cn';

// export type CustomPlugin = {
//   plugin: Plugin;
//   options?: Record<string, unknown>;
// };
export default [
  { plugin: i18n },
  { plugin: components },
  { plugin: directives },
  {
    plugin: VueBemCn,
    options: {
      hyphenate: true,
    },
  },
  { plugin: viewport },
  { plugin: api },
  { plugin: Mitt },
  { plugin: bodyScroll },
  { plugin: dayjs },
  { plugin: resizeEnd },
  { plugin: VueAxios },
  { plugin: PortalVue },
  { plugin: vFocus },
  { plugin: cdcPlugin },
  { plugin: googleTagManager },
  { plugin: confirmationModal },
  { plugin: tooltip },
];
